import React, { useContext, useEffect, useState } from 'react';
import { NavMenu } from './NavMenu';
import { Table, Typography, TableContainer, Paper, TableRow, TableHead, TableCell, TableBody, Container } from '@mui/material';
import { ConnectionAwareBackButton } from './ConnectionStatusBlip';
import PWDService from '../utils/apiClient';
import RouteContext from '../contexts/RouteContext';
import ErrorBoundary from './ErrorBoundary';
import { useSnackbar } from 'notistack';
import LoadingBackdrop from './LoadingBackdrop';

const LoadoutScreenHeader = (props) => {

    return (
        <NavMenu>
            <ConnectionAwareBackButton />
            <Typography variant="h5" sx={{ flexGrow: 1, textAlign: 'center' }}>
                {props.title}
            </Typography>
        </NavMenu>
    );
};

const LoadoutTable = (props) => {

    const { setLoading, routeNumber } = props;
    const [loadout, setLoadout] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        console.log("firing effect in LoadoutTable");
        const fetchData = async () => {
            const result = await PWDService.getLoadoutForRoute(routeNumber);
            return result;
        };
        fetchData().then((value) => {
            //console.log("fetchLoadout value", value);
            if (value) {
                const groupedResults = groupBy(value.loadoutDetails, function (item) {
                    return [item.containerAction];
                });
                setLoadout(groupedResults);
                setLoading(false);
            } else {
                setLoading(false);
                let message = 'Error loading Loadout screen';
                enqueueSnackbar(message, {
                    variant: 'error',
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'bottom'
                    }
                });
            }
        });

    },[]);

    return (
        <TableContainer component={Paper}>
            <Table aria-label="loadout table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>ACTION</TableCell>
                        <TableCell>SIZE</TableCell>
                        <TableCell>REFUSE</TableCell>
                        <TableCell>RECYCLE</TableCell>
                        <TableCell>GREEN ORGANICS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                    {Object.keys(loadout).map((actionGroup, index) => (
                        <TableRow key={index}>
                            <TableCell sx={{ borderBottom: "2px solid rgba(224, 224, 224, 1)"}} >
                                {cleanString(actionGroup)}
                            </TableCell>
                            <TableCell sx={{ padding: '0px' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell >30</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>60</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >90</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >300</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableCell>
                            <TableCell sx={{ padding: '0px' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "30", "REFUSE")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "60", "REFUSE")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                            {filterCountByContainerType(loadout[actionGroup], "90", "REFUSE")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "300", "REFUSE")}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableCell>
                            <TableCell sx={{ padding: '0px' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "30", "RECYCLE")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "60", "RECYCLE")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                            {filterCountByContainerType(loadout[actionGroup], "90", "RECYCLE")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "300", "RECYCLE")}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableCell>
                            <TableCell sx={{ padding: '0px' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "30", "GREEN ORGANICS")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "60", "GREEN ORGANICS")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                            {filterCountByContainerType(loadout[actionGroup], "90", "GREEN ORGANICS")}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell >
                                                {filterCountByContainerType(loadout[actionGroup], "300", "GREEN ORGANICS")}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

function cleanString(str){
    return str.replace(/[[\]']|["]+/g,'');
}

function filterCountByContainerType(arr, size, type) {
    let result = arr.filter(item => item.containerSize === size && item.containerType === type);
    return (result.length > 0 ? result[0].containerCount : '-');
}

function groupBy(array, f) {
    let groups = {};
    array.forEach(function (o) {
        var group = JSON.stringify(f(o));
        //console.log("group: ", group);
        groups[group] = groups[group] || [];
        groups[group].push(o);
    });

    return groups;
}

const LoadoutScreen = (props) => {
    const routeContext = useContext(RouteContext);
    let routeNumber = routeContext.containerRoute.RouteNumber;
    const [loading, setLoading] = useState(true);

    return (
        <div className="LoadoutScreen">
            <LoadoutScreenHeader title={`Loadout for Route ${routeNumber}`} />
            <ErrorBoundary>
                <Container maxWidth={false} style={{paddingLeft: 5, paddingRight: 5, marginTop: 80}}>
                    <LoadingBackdrop loading={loading} />
                    <LoadoutTable loading={loading} setLoading={setLoading} routeNumber={routeNumber} />
                </Container>
            </ErrorBoundary>
        </div>
    );
};

export default LoadoutScreen;